import { useEffect } from "react";
import { Link } from "react-router-dom";
import "./visit-us.css";
const VisitUs = () => {
  useEffect(() => {
    window.addEventListener("click", (e) => {
      e.target.tagName === "I" && e.target.classList.toggle("clicked");
    });
  }, []);

  return (
    <section className="visit-us-container" id="contact">
      <div className="row-container">
        <div className="row">
          <div>
            <i className="fas fa-dove"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-grin-stars"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-gift"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="fab fa-pagelines"></i>
          </div>
          <div>
            <i className="fas fa-dove"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-dove"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-gift"></i>
            <i className="fab fa-pagelines"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="far fa-grin-stars"></i>
          </div>
        </div>

        <div className="row">
          <div>
            <i className="fas fa-dove"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-grin-stars"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-gift"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="fab fa-pagelines"></i>
          </div>
          <div>
            <i className="fas fa-dove"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-dove"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-gift"></i>
            <i className="fab fa-pagelines"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="far fa-grin-stars"></i>
          </div>
        </div>

        <div className="row">
          <div>
            <i className="fas fa-dove"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-grin-stars"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-gift"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="fab fa-pagelines"></i>
          </div>
          <div>
            <i className="fas fa-dove"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-dove"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-gift"></i>
            <i className="fab fa-pagelines"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="far fa-grin-stars"></i>
          </div>
        </div>

        <div className="row">
          <div>
            <i className="fas fa-dove"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-grin-stars"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-gift"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="fab fa-pagelines"></i>
          </div>
          <div>
            <i className="fas fa-dove"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-dove"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-gift"></i>
            <i className="fab fa-pagelines"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="far fa-grin-stars"></i>
          </div>
        </div>

        <div className="row">
          <div>
            <i className="fas fa-dove"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-grin-stars"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-gift"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="fab fa-pagelines"></i>
          </div>
          <div>
            <i className="fas fa-dove"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-dove"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-gift"></i>
            <i className="fab fa-pagelines"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="far fa-grin-stars"></i>
          </div>
        </div>

        <div className="row">
          <div>
            <i className="fas fa-dove"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-grin-stars"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-gift"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="fab fa-pagelines"></i>
          </div>
          <div>
            <i className="fas fa-dove"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-dove"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-gift"></i>
            <i className="fab fa-pagelines"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="far fa-grin-stars"></i>
          </div>
        </div>

        <div className="row">
          <div>
            <i className="fas fa-dove"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-grin-stars"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-gift"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="fab fa-pagelines"></i>
          </div>
          <div>
            <i className="fas fa-dove"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-dove"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-gift"></i>
            <i className="fab fa-pagelines"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="far fa-grin-stars"></i>
          </div>
        </div>

        <div className="row">
          <div>
            <i className="fas fa-dove"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-grin-stars"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-gift"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="fab fa-pagelines"></i>
          </div>
          <div>
            <i className="fas fa-dove"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-dove"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-gift"></i>
            <i className="fab fa-pagelines"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="far fa-grin-stars"></i>
          </div>
        </div>

        <div className="row">
          <div>
            <i className="fas fa-dove"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-grin-stars"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-gift"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="fab fa-pagelines"></i>
          </div>
          <div>
            <i className="fas fa-dove"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-dove"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-gift"></i>
            <i className="fab fa-pagelines"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="far fa-grin-stars"></i>
          </div>
        </div>

        <div className="row">
          <div>
            <i className="fas fa-dove"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-grin-stars"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-gift"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="fab fa-pagelines"></i>
          </div>
          <div>
            <i className="fas fa-dove"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-dove"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-gift"></i>
            <i className="fab fa-pagelines"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="far fa-grin-stars"></i>
          </div>
        </div>

        <div className="row">
          <div>
            <i className="fas fa-dove"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-grin-stars"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-gift"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="fab fa-pagelines"></i>
          </div>
          <div>
            <i className="fas fa-dove"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-dove"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-gift"></i>
            <i className="fab fa-pagelines"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="far fa-grin-stars"></i>
          </div>
        </div>

        <div className="row">
          <div>
            <i className="fas fa-dove"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-grin-stars"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-gift"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="fab fa-pagelines"></i>
          </div>
          <div>
            <i className="fas fa-dove"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-dove"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-gift"></i>
            <i className="fab fa-pagelines"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="far fa-grin-stars"></i>
          </div>
        </div>

        <div className="row">
          <div>
            <i className="fas fa-dove"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-grin-stars"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-gift"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="fab fa-pagelines"></i>
          </div>
          <div>
            <i className="fas fa-dove"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-dove"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-gift"></i>
            <i className="fab fa-pagelines"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="far fa-grin-stars"></i>
          </div>
        </div>

        <div className="row">
          <div>
            <i className="fas fa-dove"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-grin-stars"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-gift"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="fab fa-pagelines"></i>
          </div>
          <div>
            <i className="fas fa-dove"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-dove"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-gift"></i>
            <i className="fab fa-pagelines"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="far fa-grin-stars"></i>
          </div>
        </div>

        <div className="row">
          <div>
            <i className="fas fa-dove"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-grin-stars"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-gift"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="fab fa-pagelines"></i>
          </div>
          <div>
            <i className="fas fa-dove"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-dove"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-gift"></i>
            <i className="fab fa-pagelines"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="far fa-grin-stars"></i>
          </div>
        </div>

        <div className="row">
          <div>
            <i className="fas fa-dove"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-grin-stars"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-gift"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="fab fa-pagelines"></i>
          </div>
          <div>
            <i className="fas fa-dove"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-dove"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-gift"></i>
            <i className="fab fa-pagelines"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="far fa-grin-stars"></i>
          </div>
        </div>

        <div className="row">
          <div>
            <i className="fas fa-dove"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-grin-stars"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-gift"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="fab fa-pagelines"></i>
          </div>
          <div>
            <i className="fas fa-dove"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-dove"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-gift"></i>
            <i className="fab fa-pagelines"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="far fa-grin-stars"></i>
          </div>
        </div>

        <div className="row">
          <div>
            <i className="fas fa-dove"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-grin-stars"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-gift"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="fab fa-pagelines"></i>
          </div>
          <div>
            <i className="fas fa-dove"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-dove"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-gift"></i>
            <i className="fab fa-pagelines"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="far fa-grin-stars"></i>
          </div>
        </div>

        <div className="row">
          <div>
            <i className="fas fa-dove"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-grin-stars"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-gift"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="fab fa-pagelines"></i>
          </div>
          <div>
            <i className="fas fa-dove"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-dove"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-gift"></i>
            <i className="fab fa-pagelines"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="far fa-grin-stars"></i>
          </div>
        </div>

        <div className="row">
          <div>
            <i className="fas fa-dove"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-grin-stars"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-gift"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="fab fa-pagelines"></i>
          </div>
          <div>
            <i className="fas fa-dove"></i>
            <i className="fas fa-heart"></i>
            <i className="fas fa-heartbeat"></i>
            <i className="fab fa-gratipay"></i>
            <i className="fas fa-grin-hearts"></i>
            <i className="far fa-kiss-beam"></i>
            <i className="fas fa-dove"></i>
            <i className="fas fa-leaf"></i>
            <i className="fas fa-horse"></i>
            <i className="far fa-grin"></i>
            <i className="fas fa-spa"></i>
            <i className="fas fa-horse"></i>
            <i className="fas fa-seedling"></i>
            <i className="fas fa-feather-alt"></i>
            <i className="fas fa-hand-holding-heart"></i>
            <i className="fas fa-gift"></i>
            <i className="fab fa-pagelines"></i>
            <i className="fas fa-tree"></i>
            <i className="fas fa-gifts"></i>
            <i className="fas fa-feather"></i>
            <i className="far fa-grin-stars"></i>
          </div>
        </div>
      </div>

      <div className="visit-us-content">
        <h2 className="visit-us-title fancy-border unobserve">Visit Us</h2>
        <address className="address unobserve">
          <p>500 Terry Francois Street, San Francisco , CA 94158</p>
          <a href="benyamin.naudi@gmail.com">benyamin.naudi@gmail.com</a> /
          <a href="tel:+1-415-555-5555">tel:+98-901-550-3984</a>
        </address>

        <div className="opening-hours unobserve">
          <h3>Opening Hours</h3>
          Mon - Fri: 7am - 10px \ Saturday: 8am - 10pm \ Sunday: 8am - 11pm
        </div>
        <div className="contact-form">
          <form>
            <div className="input-field">
              <div className="input">
                <input type="text" placeholder="Name" />
                <input type="email" placeholder="Email" />
                <input type="tel" placeholder="Phone" />
              </div>
              <div className="txt-area">
                <textarea placeholder="Message"></textarea>
              </div>
            </div>
            <button>submit</button>
          </form>
        </div>
        <Link className="directions unobserve" to="/directions">
          see directions &gt;
        </Link>
      </div>
    </section>
  );
};

export default VisitUs;
